module.exports = __webpack_public_path__ + "e36ce2e5.svg";